import { ROUTE_PATH_ADMIN } from '../../configRoutes';

export const ROUTE_PATH_PROVISIONED = ROUTE_PATH_ADMIN + '/provisioned';
export const ROUTE_PATH_PROVISIONED_NEW = ROUTE_PATH_ADMIN + '/provisioned/:gid';
